export const analyzePrompt = async (prompt, isSourceMaterial) => {
  try {
    const response = await fetch('/api/analyze', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ prompt, isSourceMaterial }),
    });

    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.error || 'The AI analysis failed.');
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error('Error calling analysis API:', error);
    throw new Error(error.message || 'A network error occurred.');
  }
};

export const improvePrompt = async (originalPrompt, answers, isSourceMaterial) => {
  try {
    const response = await fetch('/api/improve', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ originalPrompt, answers, isSourceMaterial }),
    });

    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.error || 'The prompt improvement failed.');
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error('Error calling improve API:', error);
    throw new Error(error.message || 'A network error occurred.');
  }
};